function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);}import React, { useCallback, useRef, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { DropdownList } from "../../Forms";

import { wrapDispatch } from "../../Multireducer";
import {
  ColumnItem,
  ValueItem } from "./HiddenColumnsDropdownItem";


import {
  setTableViewColumnHidden,
  setTableViewAllColumnsHidden } from "../actions/libraryActions";


import { useOnClickOutsideElement } from "../../utils/useOnClickOutsideElementHook";






const mapStateToProps = (state) => ({
  columns: state.library.ui.get('tableViewColumns')
});
const mapDispatchToProps = (dispatch) =>
bindActionCreators(
  { setTableViewColumnHidden, setTableViewAllColumnsHidden },
  wrapDispatch(dispatch, 'library')
);
const connector = connect(mapStateToProps, mapDispatchToProps);

const processColumns = (
columnsMap) =>




{
  const columns = columnsMap.toJS().slice(1);
  const hiddenColumns = columns.filter((c) => c.hidden);
  const shownColumns = columns.filter((c) => !c.hidden);
  const selectAllColumn = {
    label: 'Show all',
    selectAll: true,
    indeterminate: hiddenColumns.length !== 0 && shownColumns.length !== 0,
    hidden: shownColumns.length === 0,
    type: 'text'
  };
  const sortedColumns = [selectAllColumn].concat(
    shownColumns.concat(hiddenColumns).map((c) => _objectSpread(_objectSpread({}, c), {}, { selectAll: false }))
  );
  return { sortedColumns, hiddenColumns };
};

export const HideColumnsComponent = ({
  setTableViewAllColumnsHidden: setAllColumnsHidden,
  setTableViewColumnHidden: setColumnHidden,
  columns: columnsMap
}) => {
  const [open, setOpen] = useState(false);
  const [clickedOutside, setClickedOutside] = useState(false);

  const { sortedColumns, hiddenColumns } = processColumns(columnsMap);
  const dropdownContainerRef = useRef(null);
  const dropdownRef = useRef(null);

  const onClickOutside = useCallback((event) => {
    const target = event.target;
    if (
    target.className !== 'columns-hint' && (
    !target.parentElement || target.parentElement.className !== 'columns-hint'))
    {var _dropdownRef$current;
      setClickedOutside(true);
      (_dropdownRef$current = dropdownRef.current) === null || _dropdownRef$current === void 0 ? void 0 : _dropdownRef$current.props.onToggle(null);
    }
  }, []);

  const handleClick = () => {
    if (open) {
      setOpen(false);
    }
  };

  useOnClickOutsideElement(dropdownContainerRef, onClickOutside);

  const onSelect = (item) =>
  item.selectAll ?
  setAllColumnsHidden(item.indeterminate ? false : !item.hidden) :
  setColumnHidden(item.name, !item.hidden);

  return /*#__PURE__*/(
    React.createElement("div", { className: "hidden-columns-dropdown", ref: dropdownContainerRef }, /*#__PURE__*/
    React.createElement(DropdownList, {
      ref: dropdownRef,
      open: open,
      data: sortedColumns,
      filter: (item, searchTerm) =>
      item.label.toLowerCase().includes(searchTerm.toLowerCase()),

      itemComponent: ColumnItem,
      valueComponent: ValueItem(hiddenColumns, open, handleClick),
      onSelect: (selected) => {
        onSelect(selected);
      },
      onToggle: (value) => {
        if (value === null || clickedOutside) {var _dropdownRef$current2;
          setOpen(false);
          setClickedOutside(false);
          (_dropdownRef$current2 = dropdownRef.current) === null || _dropdownRef$current2 === void 0 ? void 0 : _dropdownRef$current2.forceUpdate();
          return;
        }
        if (!open) {
          setOpen(true);
        }
      } }
    )
    ));

};
export const HiddenColumnsDropdown = connector(HideColumnsComponent);